import { Component, HostBinding, HostListener, OnInit } from '@angular/core';
import { DataSharingService } from '../AuthGuard/DataSharingService';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
declare var $: any;
import { DatePipe } from '@angular/common';
import { constantUrl } from "../Shared/constantUrl";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { MasterService } from '../Shared/app.Masters.Service';
import { EncrDecrService } from 'src/app/AuthGuard/EncrDecrService';
import { PresenceService } from '../_Chatbox/_service/presence.service';
import { saveAs } from 'file-saver';
import { MessageService } from '../_Chatbox/_service/message.service';

@Component({
    selector: 'app-commonheader',
    templateUrl: './commonheader.component.html',
    styleUrls: ['./commonheader.component.scss'],
    standalone: false
})
export class CommonheaderComponent implements OnInit {
  @HostBinding('class.drawer-open-host') get isDrawerOpenHost() {
    return this.dropdownOpen;
  }
  CompanyName: any;
  hideNavbar: boolean = false;
  private data: any;
  username: any = "";
  FullName: any = "";
  Designation: any = "";
  Department: any = "";
  EmpEmail: any = "";
  Emp_PhoneNo: any = "";
  loginButtonShow: any = '';
  EmployeeProfileBaseUrl: any = constantUrl.apiProfilePicUrl;
  employeeid: any; ProfilePic: any;
  PasswordModel: any = [];
  MobileAPKUrl: any = constantUrl.OthersDocUrl;
  currentTheme: string = 'default';
  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };
  dropdownOpen: boolean = false;
  dropdownVisible = false;
  CompanyLogo: any;
  SUB_Heading: any;
  constructor(
    private datepipe: DatePipe,
    private dataSharingService: DataSharingService,
    private router: Router,
    public snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private _EncrDecrService: EncrDecrService,
    private presenceService: PresenceService,
    private messageService: MessageService
  ) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      var obj = JSON.parse(JSON.stringify(event));

      // Show current route in loginButtonShow
      if (obj.url != '/false') {
        this.loginButtonShow = obj.url;
      }

      // Hide navbar only on Login page
      this.hideNavbar = obj.url.split('?')[0] === '/Login';

      // Clear session if route is /Home or /
      if (obj.url == '/Home' || obj.url == '/') {
        sessionStorage.removeItem('currentUser');
        sessionStorage.clear();
        this.username = '';
      }
    });

    let usr = JSON.parse(sessionStorage.getItem('currentUser'));
    if (usr) {
      presenceService.currentUser.next(usr);
    }
  }


  getUsername() {
    this.data = JSON.parse(sessionStorage.getItem('currentUser'));
    console.log("this.currentUser", this.data);
    if (this.data != null) {
      this.username = this.data.username;
      this.FullName = this.data.FullName;
      this.employeeid = this.data.userId;
      this.ProfilePic = this.data.ProfilePic;
      this.CompanyName = this.data.CompanyName;
      this.CompanyLogo = this.data.CompanyLogo;
      this.Designation = this.data.Designation || this.data.DesignationName || this.data.Designation_Name || this.data.Desig_Name || this.data.Role_Name || this.data.RoleName || this.data.Role || '';
      this.Department = this.data.Department || this.data.DepartmentName || this.data.Department_Name || this.data.Dept_Name || '';
      this.EmpEmail = this.data.EmpEmail || this.data.Emp_Email || '';
      this.Emp_PhoneNo = this.data.Emp_PhoneNo || this.data.Mobile_No || '';

      if (this.employeeid) {
        this.messageService.Chat_GetEmployee_Detail(this.employeeid).subscribe({
          next: (res: any) => {
            if (res && res.length > 0 && res[0]) {
              this.Designation = res[0].Role_Name || res[0].Designation || this.Designation || 'Administrator';
              this.Department = res[0].Department_Name || res[0].DepartmentName || res[0].Department || this.Department;
              this.EmpEmail = res[0].Emp_Email || res[0].EmpEmail || this.EmpEmail;
              this.Emp_PhoneNo = res[0].Mobile_No || res[0].Alternet_No || res[0].Emp_PhoneNo || this.Emp_PhoneNo;
              if (this.data) {
                this.data.Designation = this.Designation;
                this.data.Department = this.Department;
                this.data.EmpEmail = this.EmpEmail;
                this.data.Emp_PhoneNo = this.Emp_PhoneNo;
                sessionStorage.setItem('currentUser', JSON.stringify(this.data));
              }
            } else if (!this.Designation) {
              this.Designation = 'Administrator';
            }
          },
          error: () => {
            if (!this.Designation) {
              this.Designation = 'Administrator';
            }
          }
        });
      }

      var Chkdate = new Date(this.data.SUB_Date.split('T')[0]);
      var Time = Chkdate.getTime() - new Date(this.datepipe.transform(new Date(), 'yyyy-MM-dd')).getTime();
      console.log("day", Time / (1000 * 3600 * 24));
      if (Time / (1000 * 3600 * 24) > 0 && Time / (1000 * 3600 * 24) < 10) {
        this.SUB_Heading = 'Your subscription is going to Expired on ' + this.datepipe.transform(this.data.SUB_Date.split('T')[0], 'dd-MM-yyyy') + '!!!'
      }
      else if (Time / (1000 * 3600 * 24) < 0) {
        this.SUB_Heading = 'Your subscription is Expired Renew Immediately!!!'
      }
      else {
        this.SUB_Heading = ''
      }
    }
    else {
      this.CompanyLogo = 'logo.png';
    }
  }

  ngOnInit() {
    this.getUsername();
    this.dataSharingService.getRefreshLoginPage().subscribe(value => {
      if (value == 'false') {
        this.username = '';
      } else {
        this.getUsername();
      }
    });

    const savedTheme = localStorage.getItem('selected-theme');
    if (savedTheme) {
      this.currentTheme = savedTheme;
      this.applyThemeClass(savedTheme);
    } else {
      this.currentTheme = 'default';
    }

    $('#menu').click(function () {
      $('#test').animate({ height: 'toggle' }, 100, function () {

      });
    });
  }
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  onImageError(event: any) {
    event.target.src = 'assets/images/default-user.png';
  }

  toggleUtilityDropdown(event?: any) {
    if (event) {
      event.stopPropagation();
    }
    this.dropdownVisible = !this.dropdownVisible;
  }

  setTheme(theme: string) {
    this.currentTheme = theme;
    if (theme === 'default') {
      localStorage.removeItem('selected-theme');
    } else {
      localStorage.setItem('selected-theme', theme);
    }
    this.applyThemeClass(theme);
  }

  applyThemeClass(theme: string) {
    const body = document.body;
    body.classList.remove(
      'theme-emerald',
      'theme-rose',
      'theme-purple',
      'theme-charcoal',
      'theme-orange',
      'theme-teal',
      'theme-blue',
      'theme-coral',
      'theme-amber'
    );
    if (theme !== 'default') {
      body.classList.add(`theme-${theme}`);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.utility-dropdown') && !target.closest('.utility-submenu') && !target.closest('.drawer-links') && !target.closest('.drawer-footer')) {
      this.dropdownVisible = false;
    }
    if (!target.closest('.profile-drawer-container')) {
      this.dropdownOpen = false;
    }
  }
  ChangePassword() {
    $('#test').animate({ height: 'toggle' }, 100, function () { });
    this.PasswordModel = {
      Old_Password: '',
      New_Password: '',
      Confirm_Password: ''
    };

    $('#ChangePasswordModal').modal('show');
    $("#ChangePasswordModal").css("z-index", "1050");
  }

  OnCloseChangePasswordModal() {
    $('#ChangePasswordModal').modal('hide');
  }
  onUpdateChangePassword() {
    if (this.PasswordModel.New_Password == this.PasswordModel.Confirm_Password) {
      this._MasterService.Update_Password({
        EmpId: this.data.userId.toString(), Old_Password: this.PasswordModel.Old_Password, New_Password: this.PasswordModel.New_Password
      }).subscribe((res: any) => {

        if (res && res[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
          this.OnCloseChangePasswordModal();
          this.router.navigate([`/UserLogout`]);
        }
        else {
          this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
        }
      });
    }
    else {
      this.snackBar.openFromComponent(SnackbarComponent, { data: "Confirm Password Same As New Password !!.", ...this.configSuccess });
    }
  }

  openSupport() {
    this._MasterService.openSupport({ SupportClientId: this.data.SupportClientId, SupportClientPassword: this.data.SupportClientPassword }).subscribe(res => {
      if (res && res.accessToken) {
        const token = res.accessToken;
        window.open(
          'https://support.finnaux.com/auth/token-callback?token=' + token,
          '_blank'
        );
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, { data: "Unable to open support. Please try again later.", ...this.configSuccess });
      }
    }, error => {
      this.snackBar.openFromComponent(SnackbarComponent, { data: "Error occurred while opening support. Please try again later.", ...this.configSuccess });
    }
    )
  }


}
